import { type EventProperties } from '@segment/analytics-next';
import { getPathPageName } from './getPathPageName';
import { analytics } from './segment';

export {
  funnelAnalytics,
  type SegmentCompletedRegistrationMethod,
} from './funnelAnalytics/funnelAnalytics';
export { ratingEvent, type RatingEventArgs } from './ratings/ratingEvent';
export {
  foodRatingModalEvent,
  type FoodRatingModalEventArgs,
} from './ratings/foodFeedbackModalVisibilityEvent';
export { Utm } from './funnelAnalytics/components/Utm/Utm';
export { UTM_SESSION_STORAGE_KEY } from './funnelAnalytics/defs';
export { homepageAnalytics } from './homepage/homepageAnalytics';
export { analytics as segmentAnalytics } from './segment';
export { trackExperimentEnrollment } from './track-experiment-enrollment';
export { onboardingButtonClicked } from './onboarding/onboardingAnalytics';
export { onboardingPreferencesShown } from './onboarding/onboardingPreferencesAnalytics';
export {
  trackProductClicked,
  type ProductClickedLocation,
} from './productClicked';
export { getUtmParamsFromSessionStorage } from './utils/getUtmParamsFromSessionStorage';
export { pairingInteraction } from './pairingInteraction';
export { productInteraction } from './productInteraction';
export {
  recipeFilterInteraction,
  groceriesFilterInteraction,
} from './filterInteraction';
export { type Location } from './pairingInteraction';
export { useSegmentPage } from './hooks/useSegmentPage';

function getOrigin() {
  return window.location.origin;
}

export type OrderPagePositionType = {
  order_id: number | null;
  button_name: string;
  page_position: string;
};

export type ButtonClickedParams = {
  button_type?: string;
  target_url?: string;
  target_url_path?: string;
} & (
  | OrderPagePositionType
  | {
      quantity_type: string;
      container_name: string;
      container_id: number;
      event_name: string;
    }
);

export async function getAnonymousId() {
  const user = await analytics.user();
  return user.anonymousId();
}

export function buttonClickedEvent(params: ButtonClickedParams) {
  const defaultValue = {
    client: 'Web',
    event_name: 'Button Clicked',
    context_app_name: 'Hungryroot Web',
    referrer_url: window.location.href,
    page_name: getPathPageName(),
  };

  const event = { ...defaultValue, ...params };
  if (event.target_url_path) {
    event.target_url = getOrigin() + params.target_url_path;
  }

  analytics.track('Button Clicked', event);
}

interface UserSearchedParams {
  order_id: number;
}

export function userSearchedEvent(params: UserSearchedParams) {
  const defaultValue = {
    event_name: 'Has Used Search',
    context_app_name: 'Hungryroot Web',
    referrer_url: window.location.href,
  };

  const event = { ...defaultValue, ...params };
  analytics.track('Has Used Search', event);
}

export function pageViewedEvent(params: EventProperties) {
  const defaultValue = {
    event_name: 'Page Viewed',
    client: 'web',
  };

  const event = { ...defaultValue, ...params };
  analytics.track('Page Viewed', event);
}
